import React from "react";
import Menu from "../../components/Menu/Menu";
import Tagline from "../../features/Tagline/Tagline";
import CTA from "../../features/CTA/CTA";
import Footer from "../../features/Footer/Footer";

export default function Home() {
  return (
    <div className="flex flex-col gap-16 bg-[#F7F4F0] w-max max-w-[100vw]">
      <Menu variant="home" />
      <div className="py-24">
        <Tagline variant="home" />
      </div>
      <CTA variant="home" />
      <Footer />
    </div>
  );
}
